// Action Types
export enum Types {
  LOAD_PIECE_TYPES = 'fabrication/LOAD_PIECE_TYPES',
  LOAD_PIECE_TYPES_SUCCESS = 'fabrication/LOAD_PIECE_TYPES_SUCCESS',
  LOAD_PIECE_TYPES_FAILURE = 'fabrication/LOAD_PIECE_TYPES_FAILURE',

  LOAD_STEEL_TYPES = 'fabrication/LOAD_STEEL_TYPES',
  LOAD_STEEL_TYPES_SUCCESS = 'fabrication/LOAD_STEEL_TYPES_SUCCESS',
  LOAD_STEEL_TYPES_FAILURE = 'fabrication/LOAD_STEEL_TYPES_FAILURE',

  LOAD_STEEL_TYPE_DIAMETERS = 'fabrication/LOAD_STEEL_TYPE_DIAMETERS',
  LOAD_STEEL_TYPE_DIAMETERS_SUCCESS = 'fabrication/LOAD_STEEL_TYPE_DIAMETERS_SUCCESS',
  LOAD_STEEL_TYPE_DIAMETERS_FAILURE = 'fabrication/LOAD_STEEL_TYPE_DIAMETERS_FAILURE',

  LOAD_WIRE_TYPES = 'fabrication/LOAD_WIRE_TYPES',
  LOAD_WIRE_TYPES_SUCCESS = 'fabrication/LOAD_WIRE_TYPES_SUCCESS',
  LOAD_WIRE_TYPES_FAILURE = 'fabrication/LOAD_WIRE_TYPES_FAILURE'
}

export interface IFabricationState {
  pieceTypesState?: IPieceTypesState;
  steelTypesState?: ISteelTypesState;
  annealedWireTypesState: IAnnealedWireTypesState;
}

// TIPOS DE PEÇA
export interface IPieceTypesState {
  pieceTypes: IPieceType[];
  loading: boolean;
  error: boolean;
}

export interface IPieceType {
  id: EPieceTypes;
  description: string;
  measureA: boolean;
  measureB: boolean;
  measureC: boolean;
}

export enum EPieceTypes {
  Barra = 1,
  Estribo = 2,
  FerroL = 3,
  Caranguejo = 4,
  FerroU = 5,
  Bandeja = 6,
  Espiral = 7,
  Circular = 8,
  CTransp = 9,
  CGancho = 10
}

//

// TIPOS DE AÇO

export interface ISteelTypesState {
  steelTypes: ISteelType[];
  loading: boolean;
  error: boolean;
}
export interface ISteelType {
  id: number;
  description: string;
  diametersState?: ISteelTypeDiameterState;
}

// BITOLA
export interface ISteelTypeDiameterState {
  diameters: IDiameter[];
  loading: boolean;
  error: boolean;
}
export interface IDiameter {
  id: number;
  steelTypeId: number;
  size: number;
  stirrupBend: number;
  circularFold: number;
  ml: number;
}

// ARAME RECOZIDO
export interface IAnnealedWireTypesState {
  selectedContractNumber?: string;
  wireTypes?: IAnnealedWireType[];
  loading: boolean;
  error: boolean;
}

export interface IAnnealedWireType {
  id: string;
  description: string;
}
